import React, { useEffect, useContext } from "react";
import { BsFillFileEarmarkTextFill } from "react-icons/bs";
import { IoReorderFourSharp } from "react-icons/io5";
import { FaGears } from "react-icons/fa6";
import NestedOption from "../../Components/NestedOption";
import { AgentContext } from "../../Pages/Agent/AgentFormsAndServices";
function RenderAgentFormList(props) {
  const { forms, customPath, service } = props;
  const handleStartForm = useContext(AgentContext);


  return (
    <ul style={{ padding: "0" }}>
      {forms &&
        forms
          .sort((a, b) => {
            return a.position - b.position;
          })
          .map((form) => {
            return (
              <div className = "cursor-pointer" onClick={() => handleStartForm(service, form)}>
                <NestedOption
                  isAgent={true}
                  optionId={form.formId}
                  optionText={form.formName ? form.formName : form.name}
                  icon={<BsFillFileEarmarkTextFill size={15} style = {{color : 'var(--accent-color)'}}/>    }
                  // optionPath = {"/formsandfields/"+ form.formId}
                  // optionPath = {customPath+ "/" + form.formId}
                ></NestedOption>
              </div>
            );
          })}
    </ul>
  );
}

export default RenderAgentFormList;
